const hotelData = [{
    "hotelNumber": 1,
    "title": "Virtual foreground support",
    "description": "Lorem ipsum dolor sit, amet consectetur adipisicing elit.",
    "image": "https://i.ibb.co/vPFLfxL/Rectangle-26.png",
    "rating": '4.9(20)',
    "price": 42,
    "totalPrice": 70,
    "guest": 4,
    "bedrooms": 2,
    "beds": 2,
    "baths" :2, 
  }, {
    "hotelNumber": 2,
    "title": "Polarized multimedia monitoring",
    "description": "Lorem ipsum dolor sit, amet consectetur adipisicing elit.",
    "image": "https://i.ibb.co/RN2LwCy/Rectangle-27.png",
    "rating": '4.7(15)',
    "price": 34,
    "totalPrice": 82,
    "guest": 4,
    "bedrooms": 2,
    "beds": 2,
    "baths" :2, 
  }, {
    "hotelNumber": 3,
    "title": "Configurable 4th generation model",
    "description": "Lorem ipsum dolor sit, amet consectetur adipisicing elit.",
    "image": "https://i.ibb.co/y0LBVzH/Rectangle-28.png",
    "rating": '4.9(25)',
    "price": 39,
    "totalPrice": 67,
    "guest": 4,
    "bedrooms": 2,
    "beds": 2,
    "baths" :2, 
  }]

  export default hotelData;